import type { DeliveryState } from '../../types/agent';

const GREY = '#8696A0';
const BLUE = '#4FB6EC';

const ARIA_LABEL: Record<DeliveryState, string> = {
  sending: 'Enviado',
  delivered: 'Entregue',
  read: 'Lido',
};

export function Ticks({ state }: { state: DeliveryState }) {
  const color = state === 'read' ? BLUE : GREY;
  return (
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      aria-label={ARIA_LABEL[state]}
      role="img"
      style={{ transition: 'all 200ms ease' }}
    >
      <path
        d="M1 5.5L5 9.5L11 1.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {state !== 'sending' && (
        <path
          d="M5 5.5L9 9.5L15 1.5"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}
